import pdf from "../../CV_Andrei-Tiberius_Cojocaru.pdf";

const Navigation = () => {
  return (
    <div className="navbar-container flex">
      <button className="navbar-btn-resume flex">
        <a
          href={pdf}
          download="CV_Andrei-Tiberius_Cojocaru"
          target="_blank"
          rel="noreferrer"
        >
          View CV
        </a>
      </button>
      <ul className="navbar-list flex">
        <li>
          <a href="#home">
            <button className="navbar-btn home-btn">
              <svg
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
                stroke="#fff"
              >
                <path d="M3 10.182V22h18V10.182L12 2z" />
              </svg>
            </button>
          </a>
        </li>
        <li>
          <a href="#projects">
            <button className="navbar-btn projects-btn">
              <svg fill="none" viewBox="0 0 15 15">
                <path
                  d="M3.5 8.5V1.5C3.5 0.947715 3.94772 0.5 4.5 0.5H7.5L9.5 2.5H13.5C14.0523 2.5 14.5 2.94772 14.5 3.5V8.5C14.5 9.05228 14.0523 9.5 13.5 9.5H4.5M3.5 8.5C3.5 9.05229 3.94772 9.5 4.5 9.5M3.5 8.5V5.5H1.5C0.947715 5.5 0.5 5.94772 0.5 6.5V13.5C0.5 14.0523 0.947715 14.5 1.5 14.5H10.5C11.0523 14.5 11.5 14.0523 11.5 13.5V9.5H4.5"
                  stroke="#fff"
                />
              </svg>
            </button>
          </a>
        </li>
        <li>
          <a href="#about">
            <button className="navbar-btn about-btn">
              <svg viewBox="0 0 512.005 512.005">
                <path
                  fill="#fff"
                  d="M362.669,42.671h-50.815l5.896-11.793c5.269-10.538,0.998-23.353-9.541-28.622s-23.353-0.998-28.622,9.541
                    l-15.437,30.874h-16.297l-15.437-30.874c-5.269-10.538-18.083-14.81-28.622-9.541s-14.81,18.083-9.541,28.622l5.896,11.793
                    h-50.815c-35.355,0-64,28.645-64,64v341.333c0,35.355,28.645,64,64,64h213.333c35.355,0,64-28.645,64-64V106.671
                    C426.669,71.316,398.024,42.671,362.669,42.671z M384.002,448.005c0,11.791-9.542,21.333-21.333,21.333H149.336
                    c-11.791,0-21.333-9.542-21.333-21.333V106.671c0-11.791,9.542-21.333,21.333-21.333h72.149l15.437,30.874
                    c0.071,0.143,0.159,0.272,0.233,0.413c0.19,0.36,0.39,0.713,0.6,1.062c0.159,0.263,0.32,0.523,0.489,0.777
                    c0.214,0.323,0.439,0.637,0.671,0.949c0.193,0.26,0.388,0.516,0.592,0.765c0.23,0.281,0.471,0.554,0.716,0.824
                    c0.231,0.254,0.463,0.505,0.704,0.746c0.242,0.242,0.493,0.474,0.748,0.706c0.27,0.245,0.542,0.485,0.823,0.715
                    c0.249,0.204,0.506,0.399,0.766,0.593c0.311,0.232,0.625,0.456,0.948,0.67c0.255,0.169,0.515,0.331,0.779,0.49
                    c0.348,0.21,0.701,0.409,1.06,0.599c0.141,0.074,0.27,0.162,0.414,0.234c0.135,0.068,0.275,0.116,0.411,0.18
                    c0.35,0.166,0.704,0.319,1.062,0.465c0.315,0.129,0.629,0.254,0.947,0.367c0.316,0.112,0.635,0.212,0.956,0.309
                    c0.361,0.109,0.721,0.215,1.083,0.305c0.293,0.072,0.589,0.131,0.885,0.19c0.385,0.077,0.768,0.153,1.154,0.208
                    c0.302,0.044,0.605,0.072,0.908,0.103c0.374,0.038,0.747,0.075,1.121,0.092c0.337,0.016,0.675,0.015,1.014,0.015
                    c0.339,0,0.676,0.001,1.013-0.015c0.374-0.018,0.747-0.055,1.121-0.092c0.304-0.031,0.607-0.059,0.908-0.103
                    c0.386-0.056,0.769-0.131,1.154-0.208c0.296-0.06,0.592-0.118,0.885-0.191c0.363-0.089,0.723-0.195,1.083-0.304
                    c0.321-0.097,0.641-0.197,0.957-0.309c0.317-0.113,0.632-0.237,0.946-0.366c0.358-0.146,0.712-0.3,1.062-0.466
                    c0.136-0.064,0.275-0.112,0.41-0.18c0.143-0.072,0.272-0.159,0.413-0.233c0.359-0.189,0.712-0.389,1.061-0.599
                    c0.264-0.159,0.523-0.32,0.778-0.489c0.323-0.214,0.637-0.439,0.949-0.67c0.26-0.193,0.516-0.388,0.765-0.592
                    c0.281-0.23,0.554-0.471,0.824-0.716c0.254-0.231,0.505-0.463,0.747-0.704c0.242-0.242,0.474-0.493,0.705-0.747
                    c0.245-0.27,0.485-0.542,0.715-0.823c0.204-0.249,0.399-0.506,0.592-0.766c0.232-0.311,0.456-0.626,0.67-0.949
                    c0.169-0.254,0.33-0.514,0.489-0.778c0.21-0.349,0.41-0.702,0.599-1.061c0.074-0.141,0.162-0.27,0.233-0.413l15.437-30.874
                    h72.149c11.791,0,21.333,9.542,21.333,21.333V448.005z"
                />
                <path
                  fill="#fff"
                  d="M320.002,149.338h-128c-11.782,0-21.333,9.551-21.333,21.333c0,11.782,9.551,21.333,21.333,21.333h128
                    c11.782,0,21.333-9.551,21.333-21.333C341.336,158.889,331.784,149.338,320.002,149.338z"
                />
              </svg>
            </button>
          </a>
        </li>
        <li>
          <a href="#contact">
            <button className="navbar-btn contact-btn">
              <svg viewBox="0 0 24 24">
                <path
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5px"
                  d="M19.89,3.25H4.11a2,2,0,0,0-2,2v9.06a2,2,0,0,0,2,2H5.75l2.31,4a.85.85,0,0,0,1.48,0l2.32-4h8a2,2,0,0,0,2-2V5.25A2,2,0,0,0,19.89,3.25Z"
                />
              </svg>
            </button>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Navigation;
